(function () {
var badge = document.getElementById('cart-count');
var toast = document.getElementById('toast');
var toastText = document.getElementById('toast-text');
var toastTimer;
function say(msg) {
if (!toast || !toastText) return;
toastText.textContent = msg;
toast.classList.remove('opacity-0', 'translate-y-4');
clearTimeout(toastTimer);
toastTimer = setTimeout(function () { toast.classList.add('opacity-0', 'translate-y-4'); }, 2200);
}
function refreshCount() {
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (badge) badge.textContent = c.item_count; }).catch(function () {});
}
document.addEventListener('click', function (e) {
var a = e.target.closest ? e.target.closest('[data-add]') : null;
if (a) {
e.preventDefault();
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(a.getAttribute('data-add')), quantity: 1 }) })
.then(function (r) { if (!r.ok) throw 0; return r.json(); })
.then(function () { badge = document.getElementById('cart-count'); refreshCount(); say(a.getAttribute('data-name') + ' añadido al carrito'); })
.catch(function () { location.href = a.href; });
return;
}
var mega = document.getElementById('mega'), scrim = document.getElementById('mega-scrim'), megaBtn = document.getElementById('mega-btn'), chev = document.getElementById('mega-chev');
var drawer = document.getElementById('drawer');
if (e.target.closest('#mega-btn') && mega) { setMega(mega.hidden); return; }
if (e.target.closest('#mega-scrim')) { setMega(false); return; }
if (e.target.closest('[data-open-menu]') && drawer) { setDrawer(true); return; }
if (e.target.closest('[data-close-menu]')) { setDrawer(false); return; }
});
function setMega(open) {
var mega = document.getElementById('mega'), scrim = document.getElementById('mega-scrim'), btn = document.getElementById('mega-btn'), chev = document.getElementById('mega-chev');
if (!mega) return;
mega.hidden = !open; if (scrim) scrim.hidden = !open;
if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
if (chev) chev.style.transform = open ? 'rotate(180deg)' : '';
}
function setDrawer(open) {
var drawer = document.getElementById('drawer');
if (!drawer) return;
drawer.hidden = !open;
document.documentElement.style.overflow = open ? 'hidden' : '';
document.querySelectorAll('[data-open-menu]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
}
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMega(false); setDrawer(false); } });
window.matchMedia('(min-width: 768px)').addEventListener('change', function () { setDrawer(false); });
})();

/* Valoración de Google automática (nota y nº de reseñas) */
(function () {
var API = 'https://losbulvhmemptrdjygpu.supabase.co/functions/v1/public-menu?slug=haresh-sabnani-sivnani';
var KEY = 'om_google_rating_v1', TTL = 3600000;
function num(t) { return parseInt(String(t || '').replace(/[^\d]/g, ''), 10) || 0; }
function fmtCount(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
function fmtRating(r) { return (Math.round(r * 10) / 10).toFixed(1).replace('.', ','); }
function current() {
var el = document.querySelector('[data-gr-count]');
return el ? num(el.textContent) : 0;
}
function valid(r, c) {
var base = current();
return typeof r === 'number' && isFinite(r) && r >= 4 && r <= 5 && typeof c === 'number' && isFinite(c) && c > 0 && c >= base - 5;
}
function apply(r, c) {
var rt = fmtRating(r), ct = fmtCount(c);
document.querySelectorAll('[data-gr-rating]').forEach(function (e) { e.textContent = rt; });
document.querySelectorAll('[data-gr-count]').forEach(function (e) { e.textContent = ct; });
document.querySelectorAll('[data-gr-aria]').forEach(function (e) { e.setAttribute('aria-label', rt + ' de 5'); });
var t = document.title;
if (t) {
var n = t.replace(/\d[\d.]*(\s+rese(?:ñ|n)as)/i, ct + '$1').replace(/\b\d[,.]\d(\s*(?:\/\s*5|★|estrellas))/i, rt + '$1');
if (n !== t) document.title = n;
}
}
function run() {
if (!document.querySelector('[data-gr-rating],[data-gr-count]') && !/rese(?:ñ|n)as/i.test(document.title)) return;
var saved = null;
try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
if (saved && Date.now() - saved.t < TTL && valid(saved.r, saved.c)) { apply(saved.r, saved.c); return; }
var ctl = window.AbortController ? new AbortController() : null;
var timer = ctl ? setTimeout(function () { ctl.abort(); }, 5000) : null;
fetch(API, ctl ? { signal: ctl.signal } : {})
.then(function (res) { if (!res.ok) throw 0; return res.json(); })
.then(function (d) {
var r = Number(d && d.rating_avg), c = Number(d && d.rating_count);
if (!valid(r, c)) return;
apply(r, c);
try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), r: r, c: c })); } catch (e) {}
})
.catch(function () {})
.then(function () { if (timer) clearTimeout(timer); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
